export default __webpack_public_path__ + "static/media/trac_7.dd3579cd.png";